<template>
    <div style="position:relative" v-bind:class="{'open':openSuggestion}">
        <input class="form-control form-control-lg" type="text" :value="value"
          @input="updateValue($event.target.value)"
          :placeholder="placeholder"
          @keydown.enter = 'enter'
          @keydown.down = 'down'
          @keydown.up = 'up'
        >
        <ul class="dropdown-menu" style="width:100%; max-height: 200px; overflow-y: auto;">
            <li v-for="(suggestion, index) in matches"
                :key="index"
                v-bind:class="{'active': isActive(index)}"
                @click="suggestionClick(index)"
                >
              <a href="#">{{ displayText(suggestion) }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    suggestions: {
      type: Array,
      required: true
    },
    keys: {
      type: Array,
      required: true
    },
    display: {
      type: Array,
      required: true
    },
    subtitle: {
      type: String
    },
    onSelected: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      open: false,
      // valueComp: '',
      current: 0
    };
  },

  computed: {
    // valueComp() {
    //   return this.value;
    // },
    matches() {
      return this.suggestions.filter(obj => {
        return (() => {
          var tempStat = false;
          var arrLen =this.keys.length;
            for(var i = 0; i < arrLen; i++){
            var haystack =  obj[this.keys[i]].toLowerCase();
            var needle =  this.value.toLowerCase();
            tempStat = haystack.indexOf(needle) >= 0
            if(tempStat){
              break;
            }
          }
          return tempStat;
        })();
      });
    },
    openSuggestion() {
      return (
        this.selection !== "" && this.matches.length !== 0 && this.open === true
      );
    }
  },
  methods: {
    updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.$emit("input", value);
    },
    // When enter pressed on the input
    enter() {
      // this.$emit("input", .city);
      this.onSelected(this.matches[this.current]);
      this.valueComp = this.displayText(this.matches[this.current]);
      // this.$emit("input", );
      // this.displayText(this.current);
      this.open = false;
    },
    displayText(suggestion) {
      var finalDisplay ='';
      this.display.map(key => finalDisplay += " "+ suggestion[key]);
      return finalDisplay;
    },
    // When up pressed while suggestions are open
    up() {
      if (this.current > 0) {
        this.current--;
      }
    },
    // When up pressed while suggestions are open
    down() {
      if (this.current < this.matches.length - 1) {
        this.current++;
      }
    },
    // For highlighting element
    isActive(index) {
      return index === this.current;
    },

    // When one of the suggestion is clicked
    suggestionClick(index) {
      // this.$emit("input", this.matches[index].city);
      // this.onSelected(this.matches[this.current])
      this.onSelected(this.matches[index]);
      this.valueComp = this.displayText(this.matches[index])
      // this.$emit("input", this.displayText(this.current));
      this.open = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Autocomplete.vue